<template>
  <div>
    <div style="width: 100%; height: 200px" v-bind:id="id"></div>
  </div>
</template>

<script>
import { getUUID } from '../../../../../utils/util'
let unwatch, myChart
export default {
  name: 'NestedRing',
  components: {},
  data() {
    return {
      id: getUUID(),
    }
  },
  props: {
    data: {
      default: [],
    },
    total: {
      type: Number,
    },
  },
  methods: {
    set(data) {
      var option
      var bdata = []
      var sdata = []
      data.map((item) => {
        if (item.name == '在线' || item.name == '库存') {
          sdata.push(item)
        } else {
          bdata.push(item)
        }
      })
      option = {
        color: ['#5470C6', '#91CC75', '#FAC859', '#F9CFC5'],
        title: {
          subtext: '远传水表总数：' + this.total,
          subtextStyle: {
            fontSize: '14px',
            color: '#404549',
          },
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.7)',
          textStyle: {
            color: '#FFFFFF',
          },
          formatter: function (params) {
            var allData = 0
            var result = ''
            result +=
              '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background:' +
              params.color +
              '"></span>'
            result += params.data.name + '<br>'
            result += '&nbsp&nbsp&nbsp数量 ：' + params.data.value + '<br>'
            result += '&nbsp&nbsp&nbsp占比 ：' + params.data.percentage + '<br>'
            return result
          },
        },
        legend: {
          top: '5%',
          right: '10%',
          orient: 'vertical', //垂直显示
          padding: 5, //调节legend的位置
          formatter: function (name) {
            var total = 0
            var target
            for (var i = 0, l = data.length; i < l; i++) {
              console.log(data[i])
              total += data[i].value
              if (data[i].name == name) {
                target = data[i].percentage
              }
            }
            var arr = ['{a|' + name + ' }{b|' + target + '}']
            return arr.join('\n')
          },
          textStyle: {
            rich: {
              a: {
                fontSize: 12,
                align: 'left',
                padding: [0, 0, 0, 0],
              },
              b: {
                fontSize: 12,
                align: 'left',
                padding: [0, 0, 0, 0],
                'letter-spacing': '0.48px',
                color: '#666666',
              },
            },
          },
        },
        series: [
          {
            center: ['23%', '55%'],
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '50%'],
            label: {
              position: 'inner',
              fontSize: 14,
            },
            labelLine: {
              show: false,
            },
            data: sdata,
          },
          {
            center: ['23%', '55%'],
            type: 'pie',
            radius: ['50%', '75%'],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: bdata,
          },
        ],
      }

      myChart.setOption(option)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
    },
    drawRingGraph(id) {
      let _this = this
      myChart = echarts2.init(document.getElementById(id))

      unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue.length != 0) {
            console.log(newvalue, 'newvalue')
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
  },
  mounted() {
    this.drawRingGraph(this.id)
  },
  created() {},
  beforeDestroy() {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!myChart?.isDisposed) {
      myChart.dispose()
    }
  },
}
</script>
<style lang="less" scoped>
</style>
